export default "__VITE_ASSET__DUflLUui__"